export default RAILS_ASSET_URL("/before-after-audi-a5-bird-droppings-before.webp")
